export default "__VITE_ASSET__XctRX1Sf__"